var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin_rounded_circle [#620]") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-383.000000, -5439.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334,5297 C332.178,5297 329,5290.009 329,5286 C329,5283.243 331.243,5281 334,5281 C336.757,5281 339,5283.243 339,5286 C339,5290.009 335.822,5297 334,5297 M334,5279 C330.134,5279 327,5282.134 327,5286 C327,5289.866 330.134,5299 334,5299 C337.866,5299 341,5289.866 341,5286 C341,5282.134 337.866,5279 334,5279 M334,5287.635 C333.449,5287.635 333,5287.187 333,5286.635 C333,5286.084 333.449,5285.635 334,5285.635 C334.551,5285.635 335,5286.084 335,5286.635 C335,5287.187 334.551,5287.635 334,5287.635 M334,5283.635 C332.343,5283.635 331,5284.979 331,5286.635 C331,5288.292 332.343,5289.635 334,5289.635 C335.657,5289.635 337,5288.292 337,5286.635 C337,5284.979 335.657,5283.635 334,5283.635",
    id: "pin_rounded_circle-[#620]"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinWhite);
export default __webpack_public_path__ + "static/media/PinWhite.c005430f469498f5f7f2433154bdb0c6.svg";
export { ForwardRef as ReactComponent };